import React from 'react'
import {useTranslation} from 'react-i18next'

import {NamedColors} from 'src/designSystem/colors'
import {BottomSheet} from 'src/designSystem/components/atoms/BottomSheet/BottomSheet'
import Box from 'src/designSystem/components/atoms/Box/Box'
import PFText from 'src/designSystem/components/atoms/PFText/PFText'
import {SvgIcon} from 'src/designSystem/components/atoms/SvgIcon/SvgIcon'
import {TrackAppEvent} from 'src/lib/Analytics/analytics_compat'
import {AppEvents, CashAdvanceEvents} from 'src/lib/Analytics/app_events'

type Props = {
  showBottomSheet: boolean
  onHideBottomSheet: () => void
  onMakeManualPayment: () => void
  amountOutstanding: string
}

const MembershipIsCanceledBottomSheet = (props: Props): JSX.Element => {
  const {
    onHideBottomSheet,
    showBottomSheet,
    onMakeManualPayment: handleMakeManualPayment,
    amountOutstanding,
  } = props

  const {t} = useTranslation('MembershipIsCanceledBottomSheet')

  TrackAppEvent(
    CashAdvanceEvents.cash_membership_is_canceled_bottom_sheet_viewed,
    AppEvents.Category.CashAdvance,
  )

  const bottomSheetContent = (
    <Box gap="small" background={NamedColors.WHITESMOKE} padding={'medium'} radius={'small'}>
      <Box gap="small">
        <SvgIcon name={'warning'} colorVariant={'warning'} size={'enormous'} />
        <PFText variant="h3">{t('YouHaveOutstandingBalance', {amount: amountOutstanding})}</PFText>
        <PFText variant="p">{t('YourAutoPayAuthorizationWillRemain')}</PFText>
      </Box>
    </Box>
  )

  const makeAManualPaymentButtonCTA = {
    text: t('MakeAManualPayment'),
    testID: 'Make-a-Manual-Payment-Button',
  }

  return (
    <BottomSheet
      title={t('MembershipIsCanceled')}
      titleVariant="h3"
      titleAlign="left"
      testID="Membership-Is-Canceled-BottomSheet"
      visible={showBottomSheet}
      showDots={false}
      showCloseButton
      closeButtonAction={onHideBottomSheet}
      onDismiss={handleMakeManualPayment}
      dismissButton={makeAManualPaymentButtonCTA}
    >
      {bottomSheetContent}
    </BottomSheet>
  )
}

export {MembershipIsCanceledBottomSheet}
